import { __toESM } from "../../../_virtual/rolldown:runtime.js";
import { require_index_umd } from "../../../_node_modules/hash-wasm/dist/index.umd.js";

//#region ../base/upload/md5.ts
var import_index_umd = /* @__PURE__ */ __toESM(require_index_umd(), 1);
function blobToMd5(chunk) {
	return new Promise((resolve, reject) => {
		const fileReader = new FileReader();
		fileReader.onload = async (e) => {
			if (!(e.target?.result && e.target.result instanceof ArrayBuffer)) return reject(/* @__PURE__ */ new Error("Could not read file"));
			resolve(await (0, import_index_umd.md5)(new Uint8Array(e.target.result)));
		};
		fileReader.readAsArrayBuffer(chunk);
	});
}

//#endregion
export { blobToMd5 };